<template>
  <div class="container-fluid">
    <v-header />
    <div class="container">
      <div class="col-12 col-lg-8 mx-auto">
        <h4>
          <span class="highlight highlight-green-300">Réinitialisez</span> votre mot de passe
        </h4>
        <div class="mb-3">
          Merci de renseigner les informations pour réinitialiser votre mot de passe
        </div>
        <form class="form-reset small">
          <div class="form-label-group mb-3">
            <label
              class="form-label"
              for="inputPassword"
            >
              Mot de passe
            </label>
            <div class="input-group">
              <input
                id="inputPassword"
                v-model="password"
                :type="selected? 'text':'password'"
                class="form-control"
                autocomplete="current-password"
                placeholder=""
                required
              >
              <div
                class="cursor-pointer input-group-text bg-white border-start-0"
                @click="selected = !selected"
              >
                <v-icon
                  :icon="selected ? 'eye-blue-500': 'eye-hidden-blue-500'"
                  height="19"
                  width="19"
                />
              </div>
            </div>
          </div>
          <div class="form-label-group mb-3">
            <label
              class="form-label"
              for="inputconfirmPassword"
            >
              Confirmer le mot de passe
            </label>
            <div class="input-group">
              <input
                id="inputconfirmPassword"
                v-model="confirmPassword"
                :type="selectedConfirm? 'text':'password'"
                class="form-control"
                autocomplete="current-password"
                placeholder=""
                required
              >
              <div
                class="cursor-pointer input-group-text bg-white border-start-0"
                @click="selectedConfirm = !selectedConfirm"
              >
                <v-icon
                  :icon="selectedConfirm ? 'eye-blue-500': 'eye-hidden-blue-500'"
                  height="19"
                  width="19"
                />
              </div>
            </div>
          </div>
          <transition
            @enter="tf_slideDown"
            @leave="tf_slideUp"
          >
            <div
              v-if="error"
              class="invalid-feedback mb-3"
            >
              {{ error }}
            </div>
          </transition>
          <div class="col-12 mb-3">
            <div class="row">
              <div
                v-for="validator in validators"
                :key="validator.id"
                class="col-12 col-md-6 col-lg-4 flex-row d-flex fs-14 text-gray-600 mb-1"
              >
                <font-awesome-icon
                  :icon="validator.isValid ? ['fas', 'check']: ['fas', 'circle']"
                  class="d-flex me-1 my-auto"
                  :class="validatorColor(validator.isValid)"
                  style="width:8px; height: 8px"
                />
                <div :class="validatorColor(validator.isValid)">
                  {{ validator.message }}
                </div>
              </div>
            </div>
          </div>
          <v-loader
            :next="changePassword"
            :disable-button="(!isPasswordValid || password !== confirmPassword)"
            title="Réinitialiser mon mot de passe"
            icon="arrow-white-right"
            class="w-100 mb-3"
          />
        </form>
      </div>
    </div>
  </div>
</template>
<script>
import { routing, transform, ui } from '@/mixins';
import Header from '@/components/common/layout/Header.vue';
import { validatePassword } from '@/utils/validators';

export default {
  name: 'PasswordView',
  components: {
    'v-header': Header,
  },
  mixins: [routing, transform, ui],
  data() {
    return {
      title: '',
      password: '',
      confirmPassword: '',
      loading: false,
      timer: null,
      error: false,
      success: false,
      selected: false,
      selectedConfirm: false,
    };
  },
  computed: {
    validators() {
      return validatePassword(this.password, this.confirmPassword);
    },
    isPasswordValid() {
      return !(this.validators.some(({ isValid }) => !isValid));
    },
  },
  methods: {
    validatorColor(value) {
      if (value === null) return 'text-gray-500';
      return value ? 'text-green-700' : 'text-red-500';
    },
    async changePassword() {
      const { id } = this.$route.query;
      const { token } = this.$route.query;
      const { password } = this;
      const { confirmPassword } = this;
      await this.$store.dispatch('client/resetPassword', {
        id, token, password, confirmPassword,
      });
      const message = 'Mot de passe réinitialisé !';
      this.ui_showToast({ show: true, message });
      this.$router.replace('/login');
    },
  },
};
</script>
